import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mountain } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { PillButton } from "../components/primitives";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await register(form.name, form.email, form.password);
      navigate(location.state?.from || "/portal", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2 font-display font-extrabold text-lg"><Mountain className="w-6 h-6 text-primary" /> La Vida Is Travel Fit</Link>
          <h1 className="mt-10 font-display font-extrabold text-3xl">Create your account</h1>
          <p className="mt-2 text-foreground/60 text-sm">Start planning your El Salvador retreat.</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <input required placeholder="Full name" value={form.name} data-testid="register-name"
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full h-12 rounded-xl border border-black/10 px-4 focus:outline-none focus:ring-2 focus:ring-primary" />
            <input required type="email" placeholder="Email" value={form.email} data-testid="register-email"
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full h-12 rounded-xl border border-black/10 px-4 focus:outline-none focus:ring-2 focus:ring-primary" />
            <input required type="password" placeholder="Password (min 6 chars)" value={form.password} data-testid="register-password"
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full h-12 rounded-xl border border-black/10 px-4 focus:outline-none focus:ring-2 focus:ring-primary" />
            {error && <div className="text-sm text-destructive" data-testid="register-error">{error}</div>}
            <PillButton type="submit" disabled={busy} data-testid="register-submit" className="w-full">{busy ? "Creating…" : "Create account"}</PillButton>
          </form>
          <p className="mt-6 text-sm text-foreground/60">Already have an account? <Link to="/login" className="text-primary font-medium">Log in</Link></p>
        </div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1616028872586-f629c1f29968?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40" />
      </div>
    </div>
  );
}
